export const FAQLinks = {
  DEBTORS: 'debtors',
  ENCASHMENT: 'encashment',
  FACTORING: 'factoring'
};

export default FAQLinks;
